import React, { useState } from "react";
import { getText, TextId } from "./Util/TextHelper";
import outlook from "../assets/icons/outlook.svg";
import { LOGGER, LogLevel } from "./Util/Logger";
import { ZensoryModule } from "../ZensoryModule";
import SpinnerLoader from "./SpinnerLoader";
import { GlobalAppState } from "./AppState";
import { getEmailDomain } from "./Util/AuthHelper";
import { getRedirectUriForMSAuth } from "./Util/FirebaseHelper";

const ConnectCalenderButton = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConnectCalender = async () => {
      // Disable button and show loader
      setIsLoading(true);
      try {
        const userId = ZensoryModule.getAuth().getCurrentUser();
        if (userId) {
        const email = GlobalAppState.getUser().email;
        const subdomain = getEmailDomain(email);
        const response = await ZensoryModule.getCalenderApi().calenderLogin({
          userId,
          redirectUri: getRedirectUriForMSAuth(),
          clientId: subdomain,
        });

        if (response?.result?.authorizationUrl) {
          window.location.href = response?.result?.authorizationUrl;
        } else {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      LOGGER.log(LogLevel.ERROR, `Error for connect caleder user: ${error}`);
      setIsLoading(false);
    }
  };

  return (
    <div
      className={`cal-connect-button custom-gradient-border ${isLoading ? 'disabled' : ''}`}
      onClick={isLoading ? null : handleConnectCalender}
      style={{ position: 'relative', pointerEvents: isLoading ? 'none' : 'auto' }}
    >
      {isLoading && (
         <SpinnerLoader />
      )}
      <span style={{ opacity: isLoading ? 0 : 1 }}>
        <img src={outlook} alt="outlook" />
      </span>
      <span style={{ opacity: isLoading ? 0 : 1 }}>{getText(TextId.calenderModalBtnText)}</span>
    </div>
  );
};

export default ConnectCalenderButton;
